<template>
      <!-- <section class="support-faq-img">
				<div class="container">
          <div class="row">

            <div class="col-lg-12 pt-5">
             
              <img :src="`assets/img/blog.png`" class="img-responsive w-100 "/>
            </div>
          </div>
					
				</div>
		</section> -->

  <div class="container margin_80_35 mt-5">
			<div class="row pt-4">
				<div class="col-lg-12" v-if="bloglist.length>0">
          <div class="row">
            <div class="col-12 faq-heading d-none">
              <h2>Blog</h2>
            </div>
            <div class="col-12">
              <carousel :data="{'items':bloglist,'type':'Blog'}"></carousel>
            </div>
          </div>
          <div class="mb-3 mt-5 container-title">
            <h3>Latest Blogs</h3>
          </div>
					<article class="wow fadeIn mb-5" style="visibility: visible; animation-name: fadeIn;"  v-for="(bloglistitem, index) in bloglist" :key="index">
						<div class="row no-gutters">
								<div class="post_info d-flex">
                  <div>
                    <img class="blog-img" :src="bloglistitem.Image ? sharedDirectory + 'BlogImage/' + bloglistitem.Image : sharedDirectory + 'DefaultImages/image_not_available.png'" alt="No Image">
                  </div>
                  <div class="ml-4"> 
                    <small><i class="fa fa-clock-o" aria-hidden="true"></i> {{new Date(bloglistitem.CreateDate).toLocaleDateString()}} <i class="ml-1 fa fa-pencil-square-o" aria-hidden="true"></i> {{bloglistitem.UserName}}</small>
                    <h5><router-link :to="{ name: 'BlogDetails', params: { Id: bloglistitem.ID }, }">{{bloglistitem.Title}}</router-link>	</h5>
                    <p class="mb-0">{{ bloglistitem.PreviewDescription }}</p>
                  </div> 
								</div>
							</div>
					</article>
					<!-- /article -->
				</div>
				<!-- /col -->
			</div>
			<!-- /row -->
		</div>
</template>

<script>
import BlogService from '../services/blog-service'
import Carousel from '../components/Common/carousel'

export default {
  name: 'BlogList',
  data() {
    return {
      bloglist: [],
      sharedDirectory: process.env.VUE_APP_SHARED_DIRECTORY
    }
  },
  components: {
    Carousel
  },
  filters: {
    truncate: function (text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...'
      } else {
        return text
      }
    },
  },
  mounted() {
    this.getBlogs()
  },
  methods: {
    getBlogs() {
      BlogService.getBlogList().then(response => {
        this.bloglist = response.data.Object.blogs
      }),
      error => {
        console.log(error)
      }
    }
  }
}
</script>

